import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Breadcrumb from '../../shared/Breadcrumb';

class Promotion extends Component {
  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '販促管理', href: '', active: true },
    ];
    return (
      <Breadcrumb items={crumb} />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(Promotion);
